import React from 'react';
import avatar from '../../assets/avatar.png';

const Avatar = (props) => {
    return (
        <figure className="dropdown__avatar">
            <img 
              className="avatar-image"
              src={avatar}
              alt='username'
            />
         </figure>
    )
}

export default Avatar;


// WEBPACK FOOTER //
// ./src/components/common/Avatar.js